import { PkDonutChart } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const ChartAttempts = ({ data }) => {
  const t = useTranslateFn();

  const attempts = useMemo(() => (data && data.length && data[0]) ?? 0, [data]);
  const onTarget = useMemo(() => (data && data.length && data[1]) ?? 0, [data]);
  const offTarget = useMemo(() => (data && data.length && data[2]) ?? 0, [data]);
  const woodWork = useMemo(() => (data && data.length && data[3]) ?? 0, [data]);
  const blocks = useMemo(() => (data && data.length && data[4]) ?? 0, [data]);

  return (
    <div className={clsx(styles.tsAttempts, 'ts-attempts')}>
      <div className={styles.tsAttemptsTitle}>{t('stats_att_attempts')}</div>
      <div className={styles.tsAttemptsChart}>
        <div className={styles.tsAttemptsChartWrap}>
          {onTarget && (
            <PkDonutChart
              series={[onTarget, offTarget, woodWork, blocks]}
              labels={[
                t('stats_attempts_OnTarget'),
                t('stats_attempts_OffTarget'),
                t('stats_match_woodwork'),
                t('stats_def_Blocks'),
              ]}
              colors={['data-01', 'data-02', 'data-03', 'data-04']}
              primaryText={t('stats_attempts_Total')}
              legendPosition='bottom'
              totalValue={attempts}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(ChartAttempts);
